export { default as Categories } from './Categories';
export { default as FeaturedProducts } from './FeaturedProducts';
export { default as Hero } from './Hero';
export { default as LatestProducts } from './LatestProducts';
export { default as News } from './News';
export { default as Newsletter } from './Newsletter';
export { default as Overview } from './Overview';
export { default as Products } from './Products';
export { default as QuickSearch } from './QuickSearch';
export { default as Reviews } from './Reviews';
export { default as Content } from './Main';
